import i18n from 'i18next';
import { i18nextConfig } from './i18next.config';
i18n.init({
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
  ...i18nextConfig,
});

export default i18n;
